import { currentMonthRange } from './collectionExport';

const LOOP_TAGLINE = 'Registraste → Gestionaste → Cobraste';

/**
 * Compone el payload de ciclo-cobro-mes con endpoints ya desplegados (fallback si 404).
 */
export async function buildCollectionCycleMonthFallback(secureFetch) {
  const range = currentMonthRange();
  const label = new Date().toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });

  const [resumenRes, impactRes, promesasRes] = await Promise.all([
    secureFetch('/api/reportes/cobranzas-resumen'),
    secureFetch(`/api/reportes/cobranzas-impacto?desde=${range.desde}&hasta=${range.hasta}`),
    secureFetch('/api/invoices/cobranzas/promesas'),
  ]);

  if (!resumenRes.ok) {
    const err = await resumenRes.json().catch(() => ({}));
    throw new Error(err.message || 'No pudimos cargar el resumen de cobranza');
  }

  const resumen = await resumenRes.json();
  const cur = resumen.mesActual || {};

  let recoveredArs = 0;
  let paymentsAttributed = 0;
  let gestionesMes = 0;
  let attributionDays = 14;
  let recentHit = null;

  if (impactRes.ok) {
    const impact = await impactRes.json();
    const summary = impact.summary || {};
    recoveredArs = summary.recoveredArs || 0;
    paymentsAttributed = summary.paymentsAttributed || 0;
    gestionesMes = summary.gestionesOutreach || 0;
    attributionDays = impact.attributionDays || 14;
    recentHit = impact.recentHits?.[0] || null;
  }

  let promesasActivas = 0;
  let promesasVencidas = 0;
  if (promesasRes.ok) {
    const prom = await promesasRes.json();
    const list = Array.isArray(prom.promesas) ? prom.promesas : [];
    promesasVencidas = prom.vencidas ?? list.filter((p) => p.vencida).length;
    promesasActivas = Math.max(0, (prom.total ?? list.length) - promesasVencidas);
  }

  return {
    period: { ...range, label },
    loopTagline: LOOP_TAGLINE,
    metrics: {
      pendienteArs: cur.pendienteActual ?? 0,
      impagas: cur.impagas ?? 0,
      gestionesMes,
      recoveredArs,
      paymentsAttributed,
      promesasActivas,
      promesasVencidas,
    },
    impact: {
      attributionDays,
      recentHit,
    },
    _source: 'fallback',
  };
}

export async function fetchCollectionCycleMonth(secureFetch) {
  const res = await secureFetch('/api/reportes/ciclo-cobro-mes');
  if (res.ok) {
    const json = await res.json();
    return { ...json, _source: 'api' };
  }
  if (res.status === 404) {
    return buildCollectionCycleMonthFallback(secureFetch);
  }
  const json = await res.json().catch(() => ({}));
  throw new Error(json.message || 'No pudimos cargar el ciclo de cobro');
}
